import React from 'react';
import { Container, Content, Col, QuestionStyle } from 'pages/new-questions/styles/common';
import { QuestionResolutionModals } from '../QuestionResolutionModals';
import { ContentStyled, RowStyledTwo } from './styles';
import { ObjectiveQuestionProps } from './utils/types';
import { useObjectiveQuestionState } from './hooks/useObjectiveQuestionState';
import { QuestionHeader, AnswerList, SubmitFooter } from './components';
import { renderImg } from './utils/utils';

const ObjectiveQuestion: React.FC<ObjectiveQuestionProps> = ({
  question,
  resolved,
  selectedAnswer,
  setSelectedAnswer,
  isTest = false,
  BackButton,
  Header,
  questionNumber,
  totalQuestions,
  handleSubmit,
}) => {
  const {
    state,
    handlePlayVideo,
    handleSubmitCheck,
    selectAnswer,
    setQuestionTextShow,
    setQuestionVideoStart,
    setModalVideoOption,
    setLSBVideo,
    setFormulaModalShow,
  } = useObjectiveQuestionState({
    question,
    isTest,
    resolved,
    selectedAnswer,
    setSelectedAnswer,
    handleSubmit,
  });

  const handleShowFormula = () => setFormulaModalShow(true);

  return (
    <Container isTest={isTest}>
      <Content isTest={isTest}>
        {Header}
        <QuestionHeader
          questionNumber={questionNumber}
          totalQuestions={totalQuestions}
          code={question.code}
          questionAnswer={state.questionAnswer}
          questionAnswerCorrect={state.questionAnswerCorrect}
          resolved={resolved}
        />
        {question.code && (
          <>
            <RowStyledTwo>
              <Col>
                <ContentStyled>
                  <QuestionStyle>
                    <div dangerouslySetInnerHTML={{ __html: question.enunciado || '' }} />
                    {renderImg(question.img_enunciado)}
                  </QuestionStyle>
                  <AnswerList
                    answers={question.answers}
                    questionAnswer={state.questionAnswer}
                    questionAnswerCorrect={state.questionAnswerCorrect}
                    onSelectAnswer={selectAnswer}
                    resolved={resolved}
                  />
                </ContentStyled>
              </Col>
            </RowStyledTwo>
            {!isTest && (
              <SubmitFooter
                BackButton={BackButton}
                questionAnswer={state.questionAnswer}
                hasCommentedQuestion={!!question.questao_comentada}
                hasVideoEmbed={!!question.video_embed}
                hasFormula={!!question.formula || !!question.formula_imagem}
                onSubmit={handleSubmitCheck}
                onReadResolution={() => setQuestionTextShow(true)}
                onWatchResolution={handlePlayVideo}
                onShowFormula={handleShowFormula}
              />
            )}
            <QuestionResolutionModals
              modalVideoOption={state.modalVideoOption}
              setModalVideoOption={setModalVideoOption}
              setIsLibrasVideo={setLSBVideo}
              questionVideoStart={state.questionVideoStart}
              setQuestionVideoStart={setQuestionVideoStart}
              isLibrasVideo={state.LSBVideo}
              videoEmbed={question?.video_embed}
              videoEmbedLibras={question?.video_embed_libras}
              questionTextShow={state.questionTextShow}
              setQuestionTextShow={setQuestionTextShow}
              questaoComentada={question?.questao_comentada}
              formulaModalShow={state.formulaModalShow}
              setFormulaModalShow={setFormulaModalShow}
              formula={question?.formula}
              formulaImagem={question?.formula_imagem}
            />
          </>
        )}
      </Content>
    </Container>
  );
};

export default ObjectiveQuestion;
